<div class="select-page-size">
  @for (item of pageSizeTemplate; track item) {
  <button (click)="onPageSizeSelect(item)"
          [class.active-size]="item.is_active" class="btn" style="outline: none; box-shadow: none;">
    <i class="fa {{item.icon}}"></i>
  </button>
  }
  <button (click)="onEditHtml()" class="btn" style="outline: none; box-shadow: none;">
    <i class="fa fa-code"></i>
  </button>
</div>
